import React, { useContext, useEffect, useState } from "react";

import UserDropdown from "components/Dropdowns/UserDropdown.js";
import { connect } from "react-redux";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import SocketContext from "helpers/SocketContext";

import NotificationDropdown from "components/Dropdowns/NotificationDropdown";
// import axios from "axios";
import { toast } from "react-toastify";
import { warningToast } from "helpers/Notification";
// import secureLocalStorage from "react-secure-storage";

const Navbar = (props) => {
  const { selectedMenu, loggedUser,systemSettings } = props;

  const mainBackground = systemSettings?.backgroundNavBar;

  // const [notifications, setNotifications] = useState([]);

  const socket = useContext(SocketContext);
  // const token = secureLocalStorage.getItem("token");
  // const fetchNotification = async () => {
  //   let config = {
  //     method: "get",
  //     url: `${process.env.REACT_APP_BACKEND_URL}/api/notification/`,
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   };

  //   const response = await axios(config);

  //   if (response.status === 200) {
  //     setNotifications(response.data?.notification?.data);
  //   }
  // };

  // useEffect(() => {
  //   fetchNotification();
  // }, []);

  useEffect(() => {
    if (socket) {
      socket.emit("addUser", loggedUser?.Resource?.id);
      socket.on("getNotification", async (notification) => {
        if (notification.type === "project_assigned") {
          warningToast("you may have new project assigned");
        } else {
          if (notification?.type)
            warningToast("you may have new notification");
        }
        // await fetchNotification();
      });
    }
  }, [socket]);

  return (
    <>
      {/* Navbar */}
      <nav style={{backgroundColor:mainBackground}} className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center">
        <div className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
          {/* Brand */}
          <a
            className="text-white text-sm uppercase hidden lg:inline-block font-semibold"
            href="#pablo"
            onClick={(e) => e.preventDefault()}
          >
            {/* if url path includes profile alway be profile */}
            {window.location.pathname.includes("profile")
              ? "Profile"
              : selectedMenu?.title ?? ""}
          </a>
          {/* Form */}
          {/*<form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">*/}
          {/*  <div className="relative flex w-full flex-wrap items-stretch">*/}
          {/*    <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">*/}
          {/*      <i className="fas fa-search"></i>*/}
          {/*    </span>*/}
          {/*    <input*/}
          {/*      type="text"*/}
          {/*      placeholder="Search here..."*/}
          {/*      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*</form>*/}
          {/* User */}

          {/* notification Icon */}

          <ul
            className="flex-col md:flex-row list-none items-center hidden md:flex mr-4"
            style={{
              marginRight: "100px",
              padding: "4px",
              margin: "10px",
              gap: "10px",
            }}
          >
            <NotificationDropdown {...props} />
            <UserDropdown {...props} />
          </ul>
        </div>
      </nav>
      {/* End Navbar */}
    </>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
